<template>
    <div class="container-fluid">
        <div class="row project-cards">
            <div class="col-sm-12">
                <SalariesTable />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import getImage from "@/mixins/getImage"

import SalariesTable from "@/components/tmkt/salaries/table.vue"
import EmployeeAbsenceModal from "@/components/tmkt/employees/employee_absence_modal.vue"

import ws from '@/services/employees'

export default {
    name: 'employees',
    components: {
        SalariesTable,
        EmployeeAbsenceModal
    },
    data(){
        return{
            employees: null 
        }
    },
    mounted: async function() {
        let response = await ws.getEmployees(); 

        if(response.type == "success"){
            this.employees = response.data;
        }
    },
    mixins: [getImage],
    computed: {
        ...mapState({
            card: (state) => state.common.usercard,
        }),
    },
}

</script>

<style scoped>
    .project-cards {
        padding-top: 30px;
    }
</style>